import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function InteractionOverlay({ active }) {
  return (
    <div className={classNames('overlay d-flex align-items-center justify-content-around', { active })}>
      {active && <i className="fas fa-spinner fa-spin" />}
    </div>
  );
}

InteractionOverlay.propTypes = {
  active: PropTypes.bool.isRequired
};

export default InteractionOverlay;
